import video1 from "../../../assets/novedades/first-story/video.mp4";
import archivo1 from "../../../assets/novedades/first-story/ResumenWebinar.pdf";

export const novedades = [
    {
        id: 1,
        titulo: "Webinar Dubái: La Cima Global de las Oportunidades Inmobiliarias",
        videoUrl: video1,
        texto:
            "¡Esto nos dejó el webinar!<br/>Si te lo perdiste pero querés estar al tanto de todo lo que está pasando en Dubái, no te preocupes: descargá la presentación completa y accedé a toda la información clave que les facilitamos para invertir con confianza.",
        archivoUrl: archivo1,
        archivoNombre: "Resumen Webinar.pdf",
        subtitulo: "Reviví los puntos clave sobre inversión segura en los EAU"
    },
];  